import {QuestionExtendedModel} from '../question-extended.model';

export class AreaFromShapeModel extends QuestionExtendedModel {

  model = {
    shapes: []
  };

  static generateModel(json: any): AreaFromShapeModel {

    const q = new AreaFromShapeModel();

    const model = json.model;
    if (model) {

      q.model.shapes = model.shapes;

    }

    return q;

  }

}
